
import React, { useEffect, useRef } from 'react'
import { useAppSelector } from '../../../hooks/redux/hooks';
import { Card, Container, Row, Col } from 'react-bootstrap';
import SmashSpinner from '../../../components/SmashSpinner/SmashSpinner';
import PlanUpgradeModal from '../../planUpgrade/components/PlanUpgradeModal';
import { planUpgradeState } from '../../planUpgrade/planUpgradeSlice';
import { usePlanUsage } from '../hooks/usePlanUsage';
import ToasterList, { useToaster } from '../../../components/Toaster/ToasterList';
import { PlanUsageDisplay } from '../models/PlanUsage.interface';
import { humanizeBytes } from '../../../shared/helpers/helpers';
import { paymentMethodState } from '../../paymentMethod/paymentMethodSlice';

const DataUsage = (planUsage: PlanUsageDisplay) => {
    const { dataUsage, dataUsageLimit, dataUsageFormat, dataUsageLimitFormat } = planUsage;
    if (dataUsageLimit) {
        return (<span className={dataUsage > dataUsageLimit ? 'text-danger' : ''}>
            {dataUsageFormat} of {dataUsageLimitFormat}
        </span>)
    } else {
        return (<span className='text-primary'>Unlimited Usage</span>)
    }
}



const PlanUsageSummary = () => {
    const [isPlanUsageLoading, planUsageDisplay, isPlanUsageError] = usePlanUsage();
    const { toastList, addToast } = useToaster();
    const { selectedPlan } = useAppSelector(planUpgradeState);
    const { payment } = useAppSelector(paymentMethodState)
    const planRef = useRef("");

    useEffect(() => {
        if (selectedPlan.plan) {
            planRef.current = selectedPlan.plan.name as string;
        }
        if (payment.paymentStatus === 'paymentSucceeded') {
            addToast({ idx: 'paymentSucceeded', theme: 'success', title: 'Success', body: () => (<>{'Successfully upgraded to ' + planRef.current}</>) })
        }
    }, [payment]);

    function getPlanName() {
        if (planUsageDisplay?.price === 0) {
            return "Free Trial"
        }
        if (planUsageDisplay?.dataUsageLimitFormat) {
            return planUsageDisplay.dataUsageLimitFormat;
        }
    }

    if (!planUsageDisplay && !isPlanUsageLoading && isPlanUsageError) {
        return (
            <div className='text-danger'>something wrong happened, contact your admin</div>
        )
    }

    return (
        <>
            {isPlanUsageLoading && <Card className="my-3 py-3">
                <SmashSpinner />
            </Card>}
            {!isPlanUsageLoading && planUsageDisplay && <Card>
                <Card.Header>
                    <Card.Title>Usage</Card.Title>
                </Card.Header>
                <Card.Body>
                    <Row>
                        <Col md={8} sm={7} xs={7}>
                            <Row className="d-flex mb-1">
                                <span className="d-flex align-items-center w-auto" style={{ fontWeight: "bold" }}>{getPlanName()}</span>
                                {planUsageDisplay.status === 'Active' && <span className='d-flex align-items-center badge text-bg-success w-auto'>{planUsageDisplay.status}</span>}
                                {planUsageDisplay.status !== 'Active' && <span className='d-flex align-items-center badge text-bg-danger w-auto'>{planUsageDisplay.status}</span>}
                            </Row>
                            <DataUsage {...planUsageDisplay} />  <span className="text-secondary">{planUsageDisplay.displayEndDateCount}</span>
                        </Col>
                        <Col className="hstack gap-3 d-flex justify-content-end align-items-center">
                            <PlanUpgradeModal />
                        </Col>
                    </Row>
                </Card.Body>
            </Card>}
            <ToasterList list={toastList} />
        </>
    )
}

export default PlanUsageSummary